module.exports = __webpack_public_path__ + "media/applicants/device_signup_4-fr-1e731d47.jpg";